export const AFFILIATION_STATE_FIELDS = `
  id
  allocation
  relation
  type
  relatedAffiliations
  invitationStatus
  roleId
  user {
    id: stringId
    affiliateOnly
    firstName
    middleName
    lastName
    primaryEmail
    phone
    gender
    taxIdExists
    dateOfBirth
    dateOfDeath
    physicalAddress { country city province streetName postal unitNumber houseNumber neighborhood }
    type
    sinExists
    employmentStatus
    maritalStatus
    companyType
    jobTitle
    studentAreaOfStudy
    citizenships
    isOfficerOfPublicCompany
    isOwnerOfPublicCompany
    isMemberOfIiroc
    politicallyExposedForeignPerson
    politicallyExposedDomesticPerson
    closeAssociateOfPEP
    headOfInternationalOrganization
    foreignTaxInformation {
      id
      foreignTaxCountry
      foreignTaxNumber
    }
    accessibleBy {
      relation
      organizationUser {
        id
      }
    }
  }
`;
